import RecapSYSHandler from 'components/Content/RecapHandler/RecapSYSHandler/RecapSYSHandler';
import { withRecapSYSHandlerProps } from 'components/Content/RecapHandler/RecapSYSHandler/withRecapSYSHandlerProps';

export default withRecapSYSHandlerProps(RecapSYSHandler);
